import React from "react";
import { Box, Link, Typography } from "@mui/material";

/** This describes the six scopes in fitbitCollectionAuthorizationScopes.js. */
const GoogleHealthDataDisclosure: React.FC = () => (
  <Box component="section" aria-labelledby="google-health-disclosure" sx={{ textAlign: "left", mb: 3 }}>
    <Typography id="google-health-disclosure" variant="h6" component="h2" sx={{ mb: 1 }}>
      How your Fitbit data will be used
    </Typography>
    <Typography variant="body2" paragraph>
      StudySync requests read-only access through Google Health to collect available
      historical and ongoing Fitbit data for your study. Your study team can use it
      in charts, collection monitoring, and research exports.
    </Typography>
    <Typography component="ul" variant="body2" sx={{ pl: 2.5, "& li": { mb: 0.75 } }}>
      <li><strong>Activity and fitness:</strong> steps, workouts, calories, and activity duration.</li>
      <li><strong>Health measurements:</strong> heart rate, heart-rate variability, breathing, oxygen, and body measurements.</li>
      <li><strong>Irregular rhythm notifications:</strong> recorded notifications, when available.</li>
      <li><strong>Nutrition:</strong> recorded food and water intake.</li>
      <li><strong>Sleep:</strong> recorded sleep sessions and stages.</li>
      <li><strong>Google Health profile:</strong> your membership start date, used to establish how far back collection can go.</li>
    </Typography>
    <Typography variant="body2" paragraph>
      Authorized researchers and collaborators in your study can view and export
      these records. StudySync uses Amazon Web Services and Google Cloud, including
      Firebase, to run the service and store study records and exports. If your
      study team enables email delivery, exports are also sent to the recipients
      they configure. Data availability varies by device and account.
    </Typography>
    <Typography variant="body2" paragraph>
      You choose whether to grant access on the next Google screen. You can stop
      future access through your{" "}
      <Link href="https://myaccount.google.com/connections" target="_blank" rel="noopener noreferrer">
        Google Account connections
      </Link>{" "}
      and contact your study team to withdraw or request deletion. Disconnecting
      does not automatically delete data already collected; retention is explained
      in your study materials and our{" "}
      <Link href="/privacy-policy" target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </Link>.
    </Typography>
    <Typography variant="body2" color="text.secondary">
      This connection does not replace your study's informed consent. If you have
      not received or understood the study information, contact the researcher
      who invited you before continuing. Links open in a new tab so you can keep
      this invitation open.
    </Typography>
  </Box>
);

export default GoogleHealthDataDisclosure;
